import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import CseData from "./DepData/cseData"
import "./style.css"; // Updated CSS file name for clarity
import Navigation from "./navigation";
import Lab1 from "./departments/cse/computer lab1.jpg";
import Lab2 from './departments/cse/computer lab2.jpg';
import Lab3 from './departments/cse/cisco lab.jpg';
import Lab4 from '../images/lab2.jpg';
import Lab5 from '../images/lab2.jpg';
import Virtual from '../images/virtual.jpg';
import cse from "../home/departments/Computer Departmet.jpg";
import ece from "../home/departments/ECE Department.jpg";
import eee from "../home/departments/EEE Department.jpg";
import mech from "../home/departments/Mech Department.jpg";
import general from "../home/departments/General Department1.jpg";
import { Navigate } from "react-router-dom";

const Cse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the backend
    fetch("https://gptkpm.in/backend/admin/cme-dept-img.php")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setData(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };
  

  return (
    <div className="cse-container">
      <Header />
      <Navigation />
      <CseData />
      <div className="notebook-container">
  <div className="notebook">
    <div className="page vision-page">
      <h2 className="page-title">Vision of the department: </h2>
      <p>
      To emerge as a capacity building, industry need based, efficient and practical knowledge hub by imparting software development skills to produce knowledgeable IT professional with ethics in order to transform students globally competent in taking up challenging tasks for holistic development of society.
      </p>
    </div>
    <div className="page mission-page">
      <h2 className="page-title">Mission of the department:</h2>
      <ul>
        <li>M1:-To impart high quality experiential learning to get expertise in modern tools relevant to the real time requirements of the industry. </li>
        <li>M2:-To inculcate problem solving and team building skills with a sense of societal and ethical responsibilities.</li>
        <li>M3:-To nourish collaborations between industry and academic as to update with the upcoming technological challenges with reliability, integrity and morality.</li>
        <li>M4:-To enhance interpersonal, entrepreneur skills and leadership qualities in proportionate with the existing industry requirements</li>
      </ul>
    </div>
    <div className="page program-objectives-page">
      <h2 className="page-title">Program Educational Objectives</h2>
      <ul>
        <li>PEO1: Work as successful computer professionals in interdisciplinary fields by applyingtheir core computing knowledge</li>
        <li>PEO2: Become entrepreneurs with leadership skills, team work and ethical values to meet societal requirements</li>
        <li>PEO3: Plan a better future by pursuing higher studies for career growth and to instil enthusiasm for lifelong learning</li>
      </ul>
    </div>
    <div className="page program-objectives-page">
      <h2 className="page-title">Program Outcomes</h2>
      <ul>
        <li>P01: Basic and discipline-specific knowledge:
        Apply knowledge of basic mathematics, science, engineering fundamentals, and an engineering specialization to solve engineering problems.</li>
        <li>P02: Problem Analysis:
        Identify and analyze well-defined engineering problems using codified standard methods.</li>
        <li>P03: Design/development of solutions:
        Design solutions for well-defined technical problems and assist with the design of systems components or processes to meet specified needs.</li>
        <li>PO4: Engineering tools, experimentation, and testing:
        Apply modern engineering tools and appropriate techniques to conduct standard tests and measurements.</li>
        <li>PO5: Engineering practices for society, sustainability, and environment:
        Apply appropriate technology in the context of society, sustainability, environment, and ethical practices.</li>
        <li>P06: Project management:
        Use engineering management principles individually, as a team member, or as a leader to manage projects and effectively communicate about well-defined engineering activities.</li>
        <li>P07:Life-long learning:
        Ability to analyze individual needs and engage in updating in the context of technological changes.</li>
      </ul>
    </div>
    <div className="page program-outcomes-page">
      <h2 className="page-title">Program Specific Outcomes</h2>
      <ul>
        <li>PSO1: Apply suitable software engineering principles in real time software project development using open source or commercial programming environment to deliver quality system</li>
        <li>PSO2: Apply basic knowledge of hardware and networking in various fields of computerengineering and adopt modern technologies in creating innovative career paths in industry and Entrepreneurship.</li>
      </ul>
    </div>
  </div>
</div>

      <div className="sec-2">
        <h3 className="section-title">Staff Members/ Faculty</h3>
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="staff-grid">
            {data.map((item) => (
              <div key={item.id} className="staff-card">
                <img
                  src={item.image}
                  alt="CSE"
                  className="staff-image"
                />
                <div className="staff-detail">
                  <h2 className="staff-name">Name: {item.name}</h2>
                  <p className="staff-profession">
                    Profession: {item.profession}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="sec-3">
        <h2>Labs</h2>
        <div id="lab">
          <div className="lab-item">
            <img src={Lab1} alt="Lab 1" />
            <p className="lab-name">COMPUTER LAB -I</p>
          </div>
          <div className="lab-item">
            <img src={Lab2} alt="Lab 2" />
            <p className="lab-name">COMPUTER LAB -II</p>
          </div>
          <div className="lab-item">
            <img src={Lab3} alt="Lab 3" />
            <p className="lab-name">HARDWARE LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab4} alt="Lab 4" />
            <p className="lab-name">CISCO ACADEMY LAB</p>
          </div>
          {/* <div className="lab-item">
            <img src={Lab5} alt="Lab 5" />
            <p className="lab-name">Lab 5</p>
          </div> */}
        </div>
      </div>
      <div id="part-5">
              <div id="part-5-left">
                <h2>Departments</h2>
                <p>Here is a list of all the departments in the college</p>
              </div>
              <div id="part-5-right" className="horizontal-scroll-container">
                <div className="img-dept">
                  <img src={cse} alt="DCME Department" />
                  <button onClick={() => handleNavigation("/cse")}>DCME</button>
                </div>
                <div className="img-dept">
                  <img src={ece} alt="DECE Department" />
                  <button onClick={() => handleNavigation("/Ece")}>DECE</button>
                </div>
                <div className="img-dept">
                  <img src={eee} alt="DEEE Department" />
                  <button onClick={() => handleNavigation("/Eee")}>DEEE</button>
                </div>
                <div className="img-dept">
                  <img src={mech} alt="DME Department" />
                  <button onClick={() => handleNavigation("/Mech")}>DME</button>
                </div>
                <div className="img-dept">
                  <img src={general} alt="General Department" />
                  <button onClick={() => handleNavigation("/General")}>General</button>
                </div>
              </div>
            </div>      
      <Footer />
    </div>
  );
};

export default Cse;
